import { render, staticRenderFns } from "./ReplacementRegister.vue?vue&type=template&id=e066a1e2&scoped=true&"
import script from "./ReplacementRegister.vue?vue&type=script&lang=js&"
export * from "./ReplacementRegister.vue?vue&type=script&lang=js&"
import style0 from "./ReplacementRegister.vue?vue&type=style&index=0&id=e066a1e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e066a1e2",
  null
  
)

export default component.exports